import { PaymentBucketResponse } from "../contracts/PaymentBucketResponse";
import { PaymentResponse } from "../contracts/PaymentResponse";
import { PaymentStatusChangeResponse } from "../contracts/PaymentStatusChangeResponse";
import { PaymentVisitLinkResponse } from "../contracts/PaymentVisitLinkResponse";
import { Payment } from "../models/Payment";
import { PaymentBucket } from "../models/PaymentBucket";
import { PaymentStatusChange } from "../models/PaymentStatusChange";
import { PaymentVisitLink } from "../models/PaymentVisitLink";

// The wire serializes absent optionals as JSON null; coerce to undefined so the
// model's optional fields behave (e.g. `x !== undefined` checks, default rendering).
export const mapResponseToPayment = (resp: PaymentResponse): Payment => ({
  id: resp.id,
  memberId: resp.memberId,
  shape: resp.shape,
  status: resp.status,
  amountMinorUnits: resp.amountMinorUnits,
  amountCurrency: resp.amountCurrency,
  paymentTypeId: resp.paymentTypeId,
  contractId: resp.contractId ?? undefined,
  visitId: resp.visitId ?? undefined,
  packSize: resp.packSize ?? undefined,
  dueDate: resp.dueDate ?? undefined,
  notes: resp.notes ?? undefined,
  invoiceNumber: resp.invoiceNumber ?? undefined,
  documentNote: resp.documentNote ?? undefined,
  remainingBalance: resp.remainingBalance ?? undefined,
  billingPeriodStart: resp.billingPeriodStart ?? undefined,
  billingPeriodEnd: resp.billingPeriodEnd ?? undefined,
  latestDebitStatus: resp.latestDebitStatus ?? undefined,
  latestDebitFailureReason: resp.latestDebitFailureReason ?? undefined,
  dateCreated: resp.dateCreated,
  dateModified: resp.dateModified,
});

export const mapResponseToStatusChange = (resp: PaymentStatusChangeResponse): PaymentStatusChange => ({
  id: resp.id,
  paymentId: resp.paymentId,
  fromStatus: resp.fromStatus,
  toStatus: resp.toStatus,
  note: resp.note,
  changedAt: resp.changedAt,
});

export const mapResponseToVisitLink = (resp: PaymentVisitLinkResponse): PaymentVisitLink => ({
  id: resp.id,
  paymentId: resp.paymentId,
  visitId: resp.visitId,
  paymentTypeId: resp.paymentTypeId,
  linkedAt: resp.linkedAt,
  unitPriceMinorUnits: resp.unitPriceMinorUnits ?? null,
});

export const mapResponseToBucket = (resp: PaymentBucketResponse): PaymentBucket => ({
  paymentTypeId: resp.paymentTypeId,
  paymentTypeName: resp.paymentTypeName,
  visitCount: resp.visitCount,
  unitPriceAmountMinorUnits: resp.unitPriceAmountMinorUnits,
  currency: resp.currency,
  subtotalAmountMinorUnits: resp.subtotalAmountMinorUnits,
});
